<template>
<v-dialog
    v-model="dialog"
    max-width="600"
>
    <v-card>
        <v-card-title>Copy Conversation</v-card-title>

        <v-card-text>
            <v-textarea
                label="Conversation"
                v-model="flat_text"
                ref="my-textarea"
            />
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                text
                @click="onCancel"
            >
            Cancel
            </v-btn>

            <v-btn
                color="primary darken-1"
                text
                @click="onOk"
            >
            Copy
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>

export default {

    data() {
        return {
            flat_text: '',
            dialog: false,
        }
    },

    methods: {

        showDialog(conversation_id)
        {
            this.$rc.showSpinner();

            this.$rc.getFlatConversation(
                conversation_id,
            
                (data) => {
                    this.$rc.hideSpinner();
                    this.flat_text = data.flat_text;
                    this.dialog = true;
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to get conversation text');
                },
            );

            
        },

        onOk()
        {
            
            let textToCopy = this.$refs['my-textarea'].$el.querySelector('textarea');
            textToCopy.select()
            document.execCommand("copy");

            this.dialog = false;
            this.$rc.snackbar('Conversation copied',3500);
        },

        onCancel()
        {
            this.dialog = false;
        },

    },
}
</script>

<style lang="scss" scoped>
</style>